/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Hide_Track_2Inputs */



/**
* | output |
* | --- |
* | "Hide Track 2" |
*
* @param {Event_Group_Options_Hide_Track_2Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_hide_track_2 = /** @type {((inputs?: Event_Group_Options_Hide_Track_2Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Hide_Track_2Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Masquer la piste 2")
	if (locale === "de") return /** @type {LocalizedString} */ ("Spur 2 ausblenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nascondi traccia 2")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скрыть трек 2")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ocultar pista 2")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("隐藏曲目 2")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トラック2を非表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रैक 2 छुपाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ocultar faixa 2")
	return /** @type {LocalizedString} */ ("Hide Track 2")
});